//Polyfill
import "core-js";

//Can't resolve 'regenerator-runtime/runtime'が表示されたとき(async awaitを使う場合など)
//import  regeneratorRuntime  from  "regenerator-runtime" ;
import jQuery from "jquery";

const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

$(document).ready(function() {
    // .header-btnがクリックされたときの処理
    $(".header-btn").click(function () {
        // .header-btnと.header-spのopenクラスをトグル（追加/削除）
        $(".header-btn, .header-sp").toggleClass("open");
    });

    // アコーディオンメニューの開閉処理
    $(".sp-nav-toggle").click(function () {
        const parentItem = $(this).parent(".sp-nav-item");
        const icon = $(this).find(".toggle-icon");

        // クリックされたメニューアイテムのopenクラスをトグル
        parentItem.toggleClass("open");

        // アイコンを+と-で切り替え
        if (parentItem.hasClass("open")) {
            icon.text("ー");
        } else {
            icon.text("＋");
        }
    });

    // .header-sp内のaタグがクリックされたときの処理
    $(".header-sp a").click(function () {
        // .header-btnと.header-spからopenクラスを削除
        $(".header-btn, .header-sp").removeClass("open");

        // アコーディオンメニューも閉じる
        $(".sp-nav-item.has-children").removeClass("open");
        $(".sp-nav-item.has-children .toggle-icon").text("+");
    });
});


document.addEventListener("DOMContentLoaded", () => {
  const swiper = new Swiper(".frontSwiper", {
    loop: true,
    slidesPerView: 1.5,
    speed: 6000,              // 連続スクロールの速度
    allowTouchMove: true,
    autoplay: {
      delay: 0,               // 連続スクロール
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    navigation: {
      nextEl: ".front-net-slide--menu--next",
      prevEl: ".front-net-slide--menu--prev",
    },
    breakpoints: {
      768: { slidesPerView: 2.7 },
    },
  });

  const nextBtn = document.querySelector(".front-net-slide--menu--next");
  const prevBtn = document.querySelector(".front-net-slide--menu--prev");

  // 連打・多重実行防止（「1回だけ」系の事故対策にも効く）
  let isNudging = false;

  const nudge = (dir) => {
    if (isNudging) return;
    isNudging = true;

    // 連続autoplayと競合しやすいので一旦止める
    swiper.autoplay?.stop();

    // クリックした分だけ確実に送る
    if (dir === "next") swiper.slideNext(450);
    else swiper.slidePrev(450);

    // 少し待ってから再開（押した感も出る）
    setTimeout(() => {
      swiper.autoplay?.start();
      isNudging = false;
    }, 900);
  };

  // Swiperのnavigationの内部処理に頼らず、確実に制御する
  nextBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    nudge("next");
  });

  prevBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    nudge("prev");
  });

  // デバッグ用（必要ならコンソールで触れる）
  window.frontSwiper = swiper;
});




document.addEventListener("DOMContentLoaded", () => {
  const pcNav = document.querySelector(".header__pc--nav");
  const inner = document.querySelector(".header--inner");

  if (!pcNav || !inner) return;

  let threshold = pcNav.offsetHeight; // PCヘッダーが消える境界
  let ticking = false;

  const update = () => {
    ticking = false;

    // スクロール量がPCヘッダーの高さを超えたら表示
    const y = window.scrollY || window.pageYOffset;
    if (y >= threshold) {
      inner.classList.add("is-sticky");
    } else {
      inner.classList.remove("is-sticky");
    }
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  const onResize = () => {
    // リサイズで高さが変わるので再計算
    threshold = pcNav.offsetHeight;
    update();
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onResize);

  // 初期反映
  update();
});

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.front-content > section');
  if (!sections.length) return;

  // IntersectionObserver がない超古い環境向けフォールバック
  if (!('IntersectionObserver' in window)) {
    sections.forEach((sec) => sec.classList.add('is-inview'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-inview');
        obs.unobserve(entry.target); // 1回表示したら監視を外す（軽量）
      });
    },
    {
      root: null,
      threshold: 0.15,          // 15%入ったら発火
      rootMargin: '0px 0px -10% 0px' // ちょい早めに発火（好みで調整OK）
    }
  );

  sections.forEach((sec, i) => {
    // ほんの少しだけ順番に出したい場合（不要なら削除OK）
    sec.style.transitionDelay = `${i * 80}ms`;
    observer.observe(sec);
  });
});


//Yotube動画
  document.addEventListener('DOMContentLoaded', () => {
    const movies = document.querySelectorAll('.movie-link');

    movies.forEach(movie => {
        // 元のHTMLを保存
        const originalHTML = movie.innerHTML;

        movie.addEventListener('click', (e) => {
            e.preventDefault();

            if (movie.querySelector('iframe')) return;

            const youtubeId = movie.dataset.youtubeId;

            // クリック時の高さを保存して固定
            const currentHeight = movie.offsetHeight;
            movie.style.height = `${currentHeight}px`;

            // iframe挿入
            movie.innerHTML = `
                <iframe
                    id="youtube-${youtubeId}"
                    src="https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0&enablejsapi=1"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen>
                </iframe>
            `;

            // YouTube IFrame API の初期化
            if (!window.YT) {
                const tag = document.createElement('script');
                tag.src = 'https://www.youtube.com/iframe_api';
                document.head.appendChild(tag);
            }

            // APIが読み込まれたら実行
            const initPlayer = () => {
                new YT.Player(`youtube-${youtubeId}`, {
                    events: {
                        onStateChange: (event) => {
                            // 動画終了時(0)に元画像に戻す
                            if (event.data === YT.PlayerState.ENDED) {
                                // フェードアウト
                                movie.style.opacity = '0';
                                movie.style.transition = 'opacity 0.3s ease';
                                
                                // フェードアウト完了後に画像に戻してフェードイン
                                setTimeout(() => {
                                    movie.innerHTML = originalHTML;
                                    // 強制的に再描画
                                    movie.offsetHeight;
                                    movie.style.opacity = '1';
                                    // 高さの固定を解除
                                    movie.style.height = '';
                                }, 300);
                            }
                        }
                    }
                });
            };

            if (window.YT && window.YT.Player) {
                initPlayer();
            } else {
                window.onYouTubeIframeAPIReady = initPlayer;
            }
        });
    });
});